import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';
import * as FIELDS from '../../fields';
import { INVOICES_REPORT_ID } from './invoicesReportId';

const defaultColumns = [
    FIELDS.BILLING_DATE.field,
    FIELDS.INVOICE_NAME.field,
    FIELDS.INVOICE_AMOUNT.field,
    FIELDS.DUE_DATE.field,
    FIELDS.PAYMENT_STATUS.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(INVOICES_REPORT_ID, field));

export { defaultColumns };
